module.exports = __webpack_public_path__ + "assets/img/bh4.8c9c1de6.jpg";